import { useQuery } from '@apollo/client/react';
import type { ResultOf } from '@guuru/graphql-common/gql';
import GET_LEADERBOARD from './queries/GetLeaderboard';

interface useLeaderboardOptionalProps {
  expertId?: string;
}

interface Separator {
  id: 'separator';
}

type LeaderboardRow =
  | NonNullable<
      ResultOf<typeof GET_LEADERBOARD>['community']
    >['leaderboard']['edges'][number]
  | Separator;

const useLeaderboard = (
  partnerId: string,
  { expertId }: useLeaderboardOptionalProps = {},
) => {
  const { loading, data } = useQuery(GET_LEADERBOARD, {
    variables: {
      partnerId,
      expertId,
      fetchExpert: !!expertId,
    },
  });

  if (loading) {
    return { loading: true, showStyleColumn: false, leaderboard: [] };
  }

  const { leaderboard: { edges = [] } = {}, expert } = data?.community || {};
  const leaderboard: LeaderboardRow[] = [...edges];

  if (expertId && expert && expert?.scores?.score !== null) {
    const isInLeaderboard = leaderboard.some((item) => {
      if ('node' in item) {
        return item.node.externalId === expertId;
      }
      return false;
    });

    if (!isInLeaderboard) {
      if (leaderboard.length === 10) {
        leaderboard.push({ id: 'separator' } as Separator);
      }
      leaderboard.push({ node: expert });
    }
  }

  return {
    loading: false,
    leaderboard: leaderboard || [],
    showStyleColumn: leaderboard.some((item) => {
      if ('node' in item) {
        return item.node.scores?.style !== null;
      }
      return false;
    }),
  };
};

export default useLeaderboard;
export type { LeaderboardRow };
